import debug from 'debug';

const logger = debug('gradebook-client');

export default logger;
